<template>
  <div class="rf-erro-perfil">
    <img src="./img/erro_perfil.png">

    <br/>
    <br/>
    Desculpe mas seu perfil não tem acesso a este módulo.
    <br/>
    <br/>
    Consulte o Administrador da sua Licença de Uso.
    <br/>

    <div>
      <RF-Button
        :cpntId='"rf-bt-erro-perfil"'
        :cpntStatus='""' 
        :cpntTexto='"Ir para página inicial"'
        :cpntClass='[ "btn", "btn-default" ]'

        @onClickButton='onButtonAcao'
      ></RF-Button>
    </div>
  </div>
</template>

<style scoped>
  .rf-erro-perfil {
    vertical-align: middle;

    text-align: center; 
    margin-left: auto; 
    margin-right: auto;
    margin-bottom: auto; 
    margin-top: auto;
  }
    .rf-erro-perfil > div {
      margin-top: 25px;
    }
</style>

<script>
  export default {
    methods: {
      onButtonAcao: function () {
        if (Object.keys(this.$store.state.token).length >= 1) {
          this.$router.push({ name: 'pag_inicial' }) // REDIRECIONA PARA TELA INICIAL
        } else {
          this.$router.push({ name: 'con_exi', params: {} }) // REDIRECIONA PARA TELA INICIAL
        }
      }
    }
  }
</script>
